/**
 * Fills Products / Blog Articles / Pages tab counts on /search.
 * Liquid only knows the active type’s results_count; the others are fetched.
 */
(() => {
  const nav = document.querySelector('[data-search-tab-counts]');

  if (!(nav instanceof HTMLElement)) return;

  const searchUrl = nav.getAttribute('data-search-url') || '/search';
  const terms = nav.getAttribute('data-terms') || '';
  const activeType = nav.getAttribute('data-active-type') || '';

  if (terms === '') return;

  const tabs = [
    {
      type: 'product',
      template: nav.getAttribute('data-products-template') || '',
    },
    {
      type: 'article',
      template: nav.getAttribute('data-articles-template') || '',
    },
    {
      type: 'page',
      template: nav.getAttribute('data-pages-template') || '',
    },
  ];

  const applyCount = (type, count) => {
    const tab = nav.querySelector(`[data-search-tab="${type}"]`);
    const meta = tabs.find((item) => item.type === type);

    if (!(tab instanceof HTMLElement) || !meta?.template) return;

    const label = meta.template.replaceAll('__COUNT__', String(count));
    const text = tab.querySelector('.button__label');

    if (text instanceof HTMLElement) {
      text.textContent = label;
      return;
    }

    const link = tab.matches('a') ? tab : tab.querySelector('a');

    if (link instanceof HTMLElement) link.textContent = label;
  };

  for (const tab of tabs) {
    if (tab.type === activeType || tab.template === '') continue;

    const url = new URL(searchUrl, window.location.origin);

    url.searchParams.set('q', terms);
    url.searchParams.set('type', tab.type);
    url.searchParams.set('section_id', 'search-counts');

    fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (html === '') return;

        const template = document.createElement('template');

        template.innerHTML = html;

        const count = Number(
          template.content.querySelector('[data-search-counts]')?.getAttribute('data-count')
        );

        if (Number.isFinite(count)) applyCount(tab.type, count);
      })
      .catch(() => {});
  }
})();
